import Vue from 'vue'
import { LiffListConfigInterface, TableDataType } from '@/components/list/types/list'
import  orderTab  from '@/modules/base/config/storeOrderTab';
class listConfig {
  protected vm?: Vue
  protected listKey?: string

  get(vm: Vue, listKey: string): LiffListConfigInterface {
    this.vm = vm
    this.listKey = listKey

    return {
      searchFilterOrder: 3,
      pageTitle: 'module.order',
      search: 'store.order.search_keyword',
      sort: [
        { label: 'data.created_at', key: 'created_at' },
      ],
      liffFilter: {
        // created_at: {
        //   label: 'data.created_at',
        //   type: 'date',
        // },
        status: {
          type: "tab",
          // create: () => {
          //   // @ts-ignore
          //   const searchKeyword = vm.searchKeyword
          //   return !searchKeyword
          // },
          options: () => {
            return orderTab
          },
        },
      },
      listItem: () => import('@/modules/store/views/orders/components/orderCardItem.vue'),
      useRow: false,
    }

  }
}

export default new listConfig()
